import { Typography } from "@/components/atoms";
import { useSiteConfig } from "@/hooks";
import { useAppSelector } from "@/redux/hooks";
import { activeOperatorSelector } from "@/redux/slices/operator/selectors";

export const GeneralLogo = () => {
  const config = useSiteConfig();
  const operator = useAppSelector(activeOperatorSelector);

  return (
    <figure className="flex flex-1 items-center gap-2">
      <img
        className="flex h-8 max-h-[32px] object-contain"
        src={operator ? operator.images.emblem : config.images.emblem}
        alt={operator ? operator.name : config.name}
      />
      <Typography variant="h3">{operator ? operator.name : config.name}</Typography>
    </figure>
  );
};
